import { createContext, useContext } from 'react';
import { en, TranslationKey } from './en';
import { nl } from './nl';
import { no } from './no';

export type Locale = 'en' | 'nl' | 'no';

const translations: Record<Locale, Record<TranslationKey, string>> = { en, nl, no };

function detectLocale(): Locale {
  const stored = localStorage.getItem('portal_locale');
  if (stored && stored in translations) return stored as Locale;

  const langs = navigator.languages || [navigator.language];
  for (const lang of langs) {
    const code = lang.toLowerCase();
    if (code.startsWith('nl')) return 'nl';
    if (code.startsWith('nb') || code.startsWith('nn') || code === 'no') return 'no';
  }
  return 'en';
}

let currentLocale: Locale = detectLocale();
let currentTranslations = translations[currentLocale];

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale) {
  currentLocale = locale;
  currentTranslations = translations[locale];
  localStorage.setItem('portal_locale', locale);
}

export function t(key: TranslationKey, params?: Record<string, string | number>): string {
  let text = currentTranslations[key] || en[key] || key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(`{${k}}`, String(v));
    }
  }
  return text;
}

export const LocaleContext = createContext<Locale>(currentLocale);

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export type { TranslationKey };
